export default [
  // orderAbout
  {
    path: '/teamHomepage',
    name: 'teamHomepage',
    component: () =>
    import(/* webpackChunkName: "team" */ '@/components/team-homepage')
  },
  // 活动消息、公告管理
  {
    path: '/teamMessage',
    name: 'teamMessage',
    component: () =>
    import(/* webpackChunkName: "teamMessage" */ '@/components/team-message')
  },
  // 公告详情
  {
    path: '/NoticeInfo',
    name: 'NoticeInfo',
    component: () =>
    import(/* webpackChunkName: "teamMessage" */ '@/components/team-message/notice-info')
  },
  {
    path: '/jointeam',
    name: 'joinTeam',
    component: () =>
    import(/* webpackChunkName: "team" */ '@/components/team-homepage/JoinTeam')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/team.js